"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductIndexItemAbstract = exports.ProductItemType = void 0;
const schemaName_1 = require("../schemaName");
var ProductItemType;
(function (ProductItemType) {
    ProductItemType["ProductLegacy"] = "product";
    ProductItemType["Product"] = "productpage";
})(ProductItemType || (exports.ProductItemType = ProductItemType = {}));
class ProductIndexItemAbstract {
    constructor() {
        this.type = ProductItemType.Product;
        this.category = "";
        this.contents = { pip: '' };
        this.description = "";
        this.format = "";
        this.ids = { globalName: '', ops: '', helios: '' };
        this.images = {};
        this.inStock = false;
        this.index = schemaName_1.SchemaName.product;
        this.keywords = "";
        this.links = { page: '' };
        this.name = "";
        this.objectID = "";
        this.occasions = [];
        this.popularity = "";
        this.price = {
            value: 0,
            currency: "",
            formatted: "",
            specification: ""
        };
        this.view = { showCategory: true };
        this.weightInCategory = 0;
        this.distinctHash = "";
    }
}
exports.ProductIndexItemAbstract = ProductIndexItemAbstract;
